import type { SeatDto, SeatState } from '@okn/shared';

/**
 * Set of state inputs the FE has at any given moment. Faz 2 only knows
 * static seat data; Faz 3+ adds the dynamic maps for reservation and hold.
 */
export type SeatStateContext = {
  reservedSeatIds?: Set<string>;
  soldSeatIds?: Set<string>;
  heldSeatIds?: Set<string>;
  selectedSeatIds?: Set<string>;
};

export function resolveSeatState(seat: SeatDto, ctx: SeatStateContext = {}): SeatState {
  if (!seat.isSellable) return 'closed';
  if (seat.kind === 'protocol') return 'protocol';
  if (ctx.soldSeatIds?.has(seat.id)) return 'sold';
  if (ctx.reservedSeatIds?.has(seat.id)) return 'reserved';
  if (ctx.heldSeatIds?.has(seat.id)) return 'held';
  return 'available';
}

// Map a state to the CSS var that fills the rect.
export const STATE_FILL_VAR: Record<SeatState, string> = {
  closed: 'var(--seat-closed)',
  protocol: 'var(--seat-protocol)',
  sold: 'var(--seat-sold)',
  reserved: 'var(--seat-reserved)',
  held: 'var(--seat-held)',
  available: 'var(--seat-available)',
};

export const STATE_LABEL_TR: Record<SeatState, string> = {
  closed: 'Kapalı',
  protocol: 'Protokol',
  sold: 'Satıldı',
  reserved: 'Rezerve',
  held: 'Tutuldu',
  available: 'Müsait',
};
